module.exports = __webpack_public_path__ + "89c3b5343e8c5375e09413d1f1185d4b.jpg";